// Modulo de reportes
export * from './reports.module';
// componente reportes
export * from './reports.component';



// WEBPACK FOOTER //
// ./src/app/reports/index.ts